export const emca_catalog = [
    "1. He tenido ansia de beber",
    "2. Habría hecho casi cualquier cosa por beber",
    "3. He deseado beber",
    "4. He podido controlar completamente mi deseo de beber",
    "5. Tomar una copa habría sido ideal",
    "6. He estado pensando la manera de ir a por una bebida",
    "7. Beber hubiera sido maravilloso",
    "8. He tenido muy a menudo la mente ocupada con imágenes relacionadas con la bebida",
    "9. Las ganas de beber han sido muy intensas",
    "10. Me hubiera sentido mejor si hubiera podido beber",
    "11. He experimentado una vez o más un intenso deseo de beber",
    "12. Aunque hubiese tenido la oportunidad no hubiera bebido",
]